import { TreeDetails } from '../../../../networkTree/types';

export interface AdActionProps {
  isPartner: boolean;
  endpointName?: string;
  companyName?: string;
}

export interface SetADResponse {
  newAdFolder: boolean;
}

export interface NewADFolderEvent {
  detail: {
    refreshTree?: TreeDetails;
  };
}

export const AD_CHANGE_EVENT = 'changeADIntegrator';
